import { Input, Select } from "antd";
import React, { useEffect } from "react";
import { defaultFoodOption } from "../../../services/food-service";
import { allowIntegerInput, allowIntegerPaste } from "../../../utils/numberFieldValidator";
import {CharLimit as charLimit} from "../../../constant/constants";
import CustomInputNumber from "../../CustomInputNumber";

function FoodAddEditForm({ records }) {
  const {
    isEditMode,
    categoryList,
    categoryDropdownList,
    categoryId,
    setCategoryId,
    name,
    setName,
    description,
    setDescription,
    defaultQuantity,
    setDefaultQuantity,
    setOptions,
  } = records;

  const onChangeCategory = (value) => {
    setCategoryId(value);

    const category = categoryList.find((cat) => cat.id === value);

    const options = category.options.map((item) => ({
      optionId: item._id,
      name: item.name,
      weight: item.weight,
      price: "",
      isSelected: category.options.length === 1,
    }));

    const filteredOptions = options.filter((op) => op.name !== "System Default");
    setOptions(filteredOptions.length === 0 ? [defaultFoodOption] : filteredOptions);
  };

  const handleFoodName = (e) => {
    const value = e.target.value;
    if (value.length > charLimit.Name) return;
    setName(value);
  };

  const handleDescription = (e) => {
    const value = e.target.value;
    if (value.length > charLimit.Details) return;
    setDescription(value);
  };

  return (
    <>
      <div className="w-full h-[45px] flex flex-row flex-nowrap items-center gap-x-[30px] mb-[30px]">
        {/* start category */}
        <div className="w-1/4 h-full">
          <div className="text-sm font-semibold flex flex-row">
            <div>Category</div>
            <div className="font-ubold text-red-700 ml-[2px]">*</div>
          </div>

          <Select
            className="w-[100%]"
            onChange={onChangeCategory}
            showSearch
            placeholder="Category"
            disabled={isEditMode}
            filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
            options={categoryDropdownList}
            value={categoryId}
          />
        </div>
        {/* end category */}

        {/* start food name  */}
        <div className={`w-2/4 h-full`}>
          <div className="text-sm font-semibold flex flex-row">
            <div>Food Name</div>
            <div className="font-ubold text-red-700 ml-[2px]">*</div>
          </div>
          <Input value={name} onChange={handleFoodName} />
          <div className="mt-1 text-[12px] text-gray-600 italic">
            Char limit 100 ({name.length})
          </div>
        </div>
        {/* end food name  */}

        {/* start default quantity  */}
        <div className="w-1/4 h-full">
          <div className="text-sm font-semibold flex flex-row">
            <div>Default Quantity</div>
            <div className="font-ubold text-red-700 ml-[2px]">*</div>
          </div>
          <CustomInputNumber value={defaultQuantity} setValue={setDefaultQuantity} min={0} max={99999}/>
        </div>
        {/* end default quantity */}
      </div>

      {/* start description */}
      <div className="w-full h-auto mb-[20px]">
        <div className="text-sm font-semibold flex flex-row">Description</div>
        <Input.TextArea
          placeholder="Enter Description (Max 2000 chacters)"
          maxLength={2000}
          rows={3}
          value={description}
          onChange={handleDescription}
        />
        <div className="mt-1 text-[12px] text-gray-600 italic">
          Char limit 2000 ({description.length})
        </div>
      </div>
      {/* end description */}
    </>
  );
}

export default FoodAddEditForm;
